import React from "react";
import ListingItem from "../../LisingItem";
import History from "../../ApplicationDetails/History";
import LsysLoans from "../../ApplicationDetails/LsysLoans";
import KreditzReportsComponent from "../KreditzReports";

const WarningsAndHistoryList = ({ application }) => {
  const lineStyle = { float: "left", whiteSpace: "normal", marginLeft: "20px" };

  return (
    <React.Fragment>
      <div style={lineStyle}>
        <ListingItem primaryText={"Loan history"} />
        <History application={application} />
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Lsys loans"} />
        <LsysLoans application={application} />
      </div>
      <div style={lineStyle}>
        <ListingItem primaryText={"Kreditz Reports"} />
        <KreditzReportsComponent application={application} />
      </div>
      {application.FraudWarnings.length > 0 && (
        <div style={lineStyle}>
          <ListingItem primaryText={"Fraud warnings"} />
          {application.FraudWarnings.map((item) => (
            // eslint-disable-next-line react/jsx-key
            <div style={{ color: "red" }}>
              {item.Type + displayNote(item.Note)}
            </div>
          ))}
        </div>
      )}
    </React.Fragment>
  );

  function displayNote(note) {
    return note ? " (" + note + ")" : "";
  }
};

export default WarningsAndHistoryList;
